import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NetworkErrorHandler } from '@yola/webapp-plugins';
import starterScreen from 'yola-editor/src/js/modules/starter-screen';
import segment from 'src/js/modules/analytics/segment';
import constants from '../constants';
import actions from '../actions';

const { NETWORK_OFFLINE, NETWORK_ONLINE } = constants;
const {
  trackers: { trackEvent },
  constants: { events, common },
} = segment;

function NetworkErrorHandlerContainer() {
  const [forceShow, setForceShow] = useState(false);
  const dispatch = useDispatch();
  const { progress } = useSelector(starterScreen.selectors.getProgress);
  const isEditorLoaded = progress === 100;

  const handleShow = useCallback(() => {
    dispatch(actions.setNetworkStatus(NETWORK_OFFLINE));
    trackEvent(events.NETWORK_CHANGED, {
      appName: common.APP_NAME,
      status: NETWORK_OFFLINE,
    });
  }, [dispatch]);

  const handleHide = useCallback(() => {
    dispatch(actions.setNetworkStatus(NETWORK_ONLINE));
    trackEvent(events.NETWORK_CHANGED, {
      appName: common.APP_NAME,
      status: NETWORK_ONLINE,
    });
    setForceShow(!isEditorLoaded);
  }, [dispatch, isEditorLoaded]);

  const handleDismiss = !isEditorLoaded ? window.location.reload : null;

  return (
    <NetworkErrorHandler
      onHide={handleHide}
      onShow={handleShow}
      onDismiss={handleDismiss}
      forceShow={forceShow}
    />
  );
}

export default NetworkErrorHandlerContainer;
